import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

const MENU_GROUPS = [
  { title: "Wallet & Payments", icon: "fas fa-wallet", items: [
    { to: "/app-notifications", icon: "fas fa-bell", title: "Notifications", notification: true },
    { to: "/app-asset", icon: "fas fa-money-bill-alt", title: "Wallet" },
    /*{ to: "/convert-balance", icon: "fas fa-exchange-alt", title: "Convert" },*/
    { to: "/withdraw", icon: "fas fa-hand-holding-usd", title: "Withdrawal" },
    /*{ to: "/deposit", icon: "fas fa-credit-card", title: "Recharge" },*/
    { to: "/withdraw-method", icon: "fas fa-university", title: "Withdrawal Method" },
  ]},
  { title: "Reports & History", icon: "fas fa-chart-bar", items: [
    { to: "/withdrawal-history", icon: "fas fa-receipt", title: "Withdrawal History" },
    { to: "/community-log", icon: "fas fa-user-lock", title: "Trade Log" },
    { to: "/transaction-history", icon: "fas fa-list-ul", title: "Transaction History" },
    { to: "/income-history", icon: "fas fa-chart-line", title: "Income History" },
  ]},
  { title: "Team & Growth", icon: "fas fa-users", items: [
    { to: "/affiliate", icon: "fas fa-bullhorn", title: "Promotion" },
    { to: "/my-smart-team", icon: "fas fa-user-friends", title: "Team Level" },
    { to: "/all-team-users", icon: "fas fa-user-friends", title: "My Team" },
    { to: "/team-statement", icon: "fas fa-list", title: "Team Statement" },
  ]},
  { title: "Account Security", icon: "fas fa-shield-alt", items: [
    { to: "/change-password", icon: "fas fa-key", title: "Change Password" },
    /*{ to: "/change-transaction-password", icon: "fas fa-unlock-alt", title: "Transaction Password" },*/
    { to: "/security", icon: "fas fa-user-lock", title: "Security" },
    /*{ to: "/identity-verification", icon: "fas fa-id-card", title: "Verification" },*/
  ]},
  { title: "Help & Support", icon: "fas fa-headset", items: [
    { to: "/support-ticket", icon: "fas fa-headset", title: "Support Ticket" },
  ]},
];

const Compose = () => {
  const history = useHistory();
  const [notificationCount, setNotificationCount] = useState(null);
  const [search, setSearch] = useState("");
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("auth_token")) return undefined;
    let active = true;
    const payload = {
      key_s: "eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9",
      currency: localStorage.getItem("selectedCurrency"),
    };
    axios.post("/notifications-count", payload)
      .then(({ data }) => {
        if (active) setNotificationCount(data?.notifaction ?? null);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const logoutSubmit = async (event) => {
    event.preventDefault();
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      const { data } = await axios.post("/logout");
      // Retain the original backend success contract.
      if (data?.message === "Unauthenticated") {
        localStorage.removeItem("auth_token");
        swal("Success", data.message, "success");
        history.push("/login");
      } else {
        swal("Warning", data?.message || "Logout was not confirmed.", "warning");
      }
    } catch (error) {
      swal("Error", "Unable to log out. Please try again.", "error");
    } finally {
      setLoggingOut(false);
    }
  };

  const groups = MENU_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => item.title.toLowerCase().includes(search.trim().toLowerCase())),
  })).filter((group) => group.items.length > 0);
  const totalItems = MENU_GROUPS.reduce((sum, group) => sum + group.items.length, 0);
  const showBadge = notificationCount !== null && notificationCount !== "" && notificationCount !== "Empty" && Number(notificationCount) > 0;

  return (
    <>
      <style>{`
        html, body, #root { background: #00191D !important; }
        body { color: #fff !important; }
        .rc-menu, .rc-menu * { box-sizing: border-box; }
        .rc-menu { --cyan:#16B8C7; --navy:#00191D; --line:rgba(58,201,212,.22); --muted:#a2bbc0; min-height:100vh; width:100%; background:#00191D; color:#fff; padding:14px 4px 34px; font-size:14px; overflow-x:hidden; }
        .rc-menu a { text-decoration:none !important; }
        .rc-wrap { max-width:1180px; margin:0 auto; width:100%; }
        .rc-hero { border:1px solid var(--line); border-radius:20px; background:linear-gradient(125deg,#073138 0%,#002329 55%,#00191D 100%); padding:22px; display:flex; align-items:center; justify-content:space-between; gap:18px; position:relative; overflow:hidden; animation:rc-rise .35s ease both; }
        .rc-hero:after { content:""; position:absolute; right:-50px; top:-80px; width:210px; height:210px; border:1px solid rgba(22,184,199,.18); border-radius:50%; pointer-events:none; }
        .rc-eyebrow { display:inline-flex; align-items:center; gap:7px; font-size:11px; text-transform:uppercase; letter-spacing:1.6px; font-weight:800; color:#63e0e8; }
        .rc-hero h1 { font-size:clamp(20px,3vw,29px); line-height:1.2; margin:7px 0; color:#fff; font-weight:800; }
        .rc-hero p { margin:0; color:#b5d1d5; font-size:13px; }
        .rc-hero-icon { width:64px; height:64px; flex:none; display:grid; place-items:center; border-radius:19px; color:#00191D; font-size:27px; background:linear-gradient(135deg,#80f0f3,#16B8C7,#078a9b); box-shadow:0 12px 28px rgba(22,184,199,.18); }
        .rc-tools { display:flex; align-items:center; justify-content:space-between; gap:12px; margin:14px 0 17px; flex-wrap:wrap; }
        .rc-search { flex:1; min-width:190px; max-width:520px; display:flex; align-items:center; gap:10px; background:#fff; border-radius:13px; padding:0 14px; color:#52747a; border:1px solid #cce3e6; }
        .rc-search input { width:100%; min-width:0; height:44px; border:0; outline:0; background:transparent; color:#12343a; font-size:14px; }
        .rc-search input::placeholder { color:#829ba0; }
        .rc-count { border:1px solid var(--line); background:#052b31; padding:10px 13px; border-radius:12px; color:#b4d8dc; font-size:12px; font-weight:700; white-space:nowrap; }
        .rc-count strong { color:#61e1e9; }
        .rc-section { background:#03262c; border:1px solid var(--line); border-radius:19px; padding:15px; margin:0 0 15px; animation:rc-rise .4s ease both; }
        .rc-section:nth-of-type(even) { background:#052b31; }
        .rc-section-header { display:flex; align-items:center; justify-content:space-between; gap:12px; margin-bottom:14px; }
        .rc-section-title { display:flex; align-items:center; gap:10px; min-width:0; }
        .rc-section-symbol { width:35px; height:35px; display:grid; place-items:center; border-radius:11px; background:rgba(22,184,199,.12); border:1px solid rgba(22,184,199,.2); color:#4cdae5; font-size:15px; }
        .rc-section-title h2 { font-size:15px; font-weight:800; color:#fff; margin:0; }
        .rc-section-meta { font-size:11px; color:#a6c6cb; white-space:nowrap; }
        .rc-grid { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:11px; }
        .rc-item { position:relative; display:flex; align-items:center; gap:11px; min-width:0; min-height:72px; padding:12px; border-radius:13px; background:#fff; border:1px solid #d8ebed; color:#15343a !important; transition:transform .18s ease,border-color .18s ease,box-shadow .18s ease; }
        .rc-item:hover, .rc-item:focus-visible { transform:translateY(-2px); border-color:#16B8C7; box-shadow:0 8px 20px rgba(0,0,0,.17); outline:none; }
        .rc-item-icon { display:grid; place-items:center; width:41px; height:41px; flex:none; border-radius:12px; background:linear-gradient(140deg,#dbfbfd,#a6eaf0); color:#087f8d; font-size:17px; }
        .rc-item-name { font-size:13px; line-height:1.35; font-weight:800; overflow-wrap:anywhere; color:#15343a; }
        .rc-item-arrow { margin-left:auto; color:#68a4ac; font-size:11px; }
        .rc-badge { position:absolute; right:7px; top:6px; border-radius:20px; min-width:19px; padding:3px 6px; background:#e94c61; color:#fff; font-size:10px; font-weight:800; text-align:center; line-height:1.2; }
        .rc-footer { background:#062a30; border:1px solid var(--line); padding:15px; border-radius:18px; display:flex; align-items:center; justify-content:space-between; gap:15px; }
        .rc-footer h3 { font-size:14px; font-weight:800; margin:0 0 4px; color:#fff; }
        .rc-footer p { font-size:12px; color:#aac8cc; margin:0; }
        .rc-logout { display:inline-flex; justify-content:center; align-items:center; gap:9px; border:0; border-radius:12px; padding:13px 24px; min-width:145px; color:#00252b; font-size:14px; font-weight:900; cursor:pointer; background:linear-gradient(110deg,#7ae8ed 0%,#16B8C7 55%,#0794a4 100%); transition:filter .18s ease,transform .18s ease; }
        .rc-logout:hover:not(:disabled) { filter:brightness(1.08); transform:translateY(-2px); }
        .rc-logout:disabled { opacity:.6; cursor:not-allowed; }
        .rc-empty { text-align:center; padding:35px 14px; color:#bdd5d9; background:#052b31; border:1px solid var(--line); border-radius:16px; }
        .rc-empty i { color:#52d6e1; display:block; font-size:24px; margin-bottom:9px; }
        @keyframes rc-rise { from { opacity:.6; transform:translateY(7px); } to { opacity:1; transform:translateY(0); } }
        @media(max-width:980px) { .rc-grid { grid-template-columns:repeat(3,minmax(0,1fr)); } }
        @media(max-width:650px) { .rc-menu { padding-top:8px; } .rc-hero { padding:17px 14px; border-radius:16px; } .rc-hero-icon { width:48px; height:48px; font-size:20px; border-radius:14px; } .rc-grid { grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px; } .rc-section { padding:11px; border-radius:15px; margin-bottom:11px; } .rc-item { min-height:68px; padding:9px; gap:8px; } .rc-item-icon { width:36px; height:36px; font-size:15px; } .rc-item-name { font-size:12px; } .rc-item-arrow { display:none; } .rc-tools { margin:11px 0; } .rc-search { max-width:none; } .rc-footer { align-items:stretch; flex-direction:column; } .rc-logout { width:100%; } }
        @media(max-width:360px) { .rc-item { flex-direction:column; text-align:center; min-height:92px; justify-content:center; } .rc-item-name { font-size:11px; } .rc-hero p { font-size:12px; } }
        @media(prefers-reduced-motion:reduce) { .rc-menu *, .rc-menu *:before, .rc-menu *:after { animation:none !important; transition:none !important; } }
      `}</style>
      <main className="rc-menu">
        <div className="rc-wrap">
          <header className="rc-hero">
            <div>
              <span className="rc-eyebrow"><i className="fas fa-layer-group" /> RM CROWN MARKET</span>
              <h1>Account Control Center</h1>
              <p>Manage your wallet, reports, team, security and support in one place.</p>
            </div>
            <div className="rc-hero-icon" aria-hidden="true"><i className="fas fa-th-large" /></div>
          </header>
          <div className="rc-tools">
            <label className="rc-search">
              <i className="fas fa-search" aria-hidden="true" />
              <input type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search account menu..." aria-label="Search account menu" />
            </label>
            <div className="rc-count"><strong>{totalItems}</strong> Account Tools</div>
          </div>
          {groups.length ? groups.map((group) => (
            <section className="rc-section" key={group.title}>
              <div className="rc-section-header">
                <div className="rc-section-title">
                  <span className="rc-section-symbol"><i className={group.icon} /></span>
                  <h2>{group.title}</h2>
                </div>
                <span className="rc-section-meta">{group.items.length} {group.items.length === 1 ? "option" : "options"}</span>
              </div>
              <div className="rc-grid">
                {group.items.map((item) => (
                  <Link to={item.to} className="rc-item" key={item.to}>
                    <span className="rc-item-icon"><i className={item.icon} /></span>
                    <span className="rc-item-name">{item.title}</span>
                    <i className="fas fa-chevron-right rc-item-arrow" aria-hidden="true" />
                    {item.notification && showBadge && <span className="rc-badge">{notificationCount}</span>}
                  </Link>
                ))}
              </div>
            </section>
          )) : <div className="rc-empty"><i className="fas fa-search" />No matching menu items found.</div>}
          <footer className="rc-footer">
            <div><h3>Secure Account Access</h3><p>Sign out safely when you finish managing your account.</p></div>
            <button type="button" className="rc-logout" onClick={logoutSubmit} disabled={loggingOut}>
              <i className="fas fa-sign-out-alt" />{loggingOut ? "Signing out..." : "Logout Account"}
            </button>
          </footer>
        </div>
      </main>
    </>
  );
};

export default Compose;
